<template>
  <div @click="openModal" style="cursor: pointer;">
    <slot></slot>
  </div>
</template>

<script>
import ModalService from '@services/ModalService'

export default {
  name: 'open-modal-button',
  props: {
    modalName: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    openModal () {
      ModalService.spawn(this.modalName, {
        resultCb: window.modalOnClose,
        ...this.params,
      })
    },
  },
}
</script>
